import { Box } from '@chakra-ui/react';

import { LocationIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import { TextRegular } from 'UiKit/typography';
import Tooltip from 'UiKit/tooltip';

import BadgeStatus from 'View/report-attendance-host-detail/component/badge-status';
import AttachmentImage from 'Component/attachment-image';
import { useReportAttendanceHostDetailState } from 'View/report-attendance-host-detail/state';

import styles from './styles.module.css';

const ColumnPresence = ({ value }) => {
  const { updateState } = useReportAttendanceHostDetailState();
  const images = (value?.images || []).map((image) => ({ url: image.url, caption: image.caption }));

  const handleOpenPreview = (images) => updateState({ isOpenImagePreview: true, selectedImagePreview: images });
  const isLocationValid = value?.location?.latitude && value?.location?.longitude;
  const handleOpenMaps = () => {
    if (isLocationValid) {
      const url = `https://www.google.com/maps/search/?api=1&query=${value.location.latitude},${value.location.longitude}`;
      window.open(url, '_blank');
    }
  };

  return (
    <Box className={styles['column-presence__container']}>
      <Box className={styles['column-presence__box--left']}>
        <AttachmentImage images={images} onOpenPreview={handleOpenPreview} />
      </Box>
      <Box className={styles['column-presence__box--middle']}>
        <BadgeStatus status={value?.timeStatus} />
        <TextRegular className={styles['column-presence__text--time']}>{value?.time || '-'}</TextRegular>
        <Tooltip className={styles['column-presence__container--notes']} label={value?.note}>
          <TextRegular className={styles['column-presence__text--notes']}>{value?.note || '-'}</TextRegular>
        </Tooltip>
      </Box>
      <Box className={styles['column-presence__box--right']}>
        <Condition statement={isLocationValid}>
          <BadgeStatus status={value?.locationStatus} />
        </Condition>
        <Box
          className={`${styles['column-presence__box--location']} ${!isLocationValid ? styles['column-presence__box--location--valid'] : ''}`}
          onClick={handleOpenMaps}
        >
          <LocationIcon size="12px" color="var(--color-primary60)" />
          <TextRegular className={styles['column-presence__text--location']}>
            <Condition statement={isLocationValid} fallback={'-'}>
              lihat maps
            </Condition>
          </TextRegular>
        </Box>
      </Box>
    </Box>
  );
};

export default ColumnPresence;
